// ============================================================
// CONFIGURATION DU SITE — MODE "studio" ou "films"
// ------------------------------------------------------------
// Pour transformer ce site en site FENEK FILMS :
//   1. frontend/.env  -> REACT_APP_SITE_MODE=films
//   2. backend/.env   -> SITE_MODE=films
//   3. supervisorctl restart backend frontend
// ============================================================

const SITE_CONFIG = {
  studio: {
    mode: "studio",
    studioType: "enregistrement",
    brandFirst: "FNK",
    brandSecond: "STUDIO",
    fullName: "FNK STUDIO",
    logo: "/logo-fenek-studio.jpg",
    subtitle: "Enregistrement · Mix · Master · Beatmaking",
    heroTitleA: "Votre espace",
    heroTitleAccentA: "créatif",
    heroTitleB: "pour donner vie à tous",
    heroTitleAccentB: "vos projets musicaux.",
    heroText:
      "Enregistrement, mix, master et beatmaking dans un studio professionnel équipé, ouvert 24h/24.",
    heroImg:
      "https://images.unsplash.com/photo-1517273006195-51fa3364bce2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHwyfHxwcm9mZXNzaW9uYWwlMjByZWNvcmRpbmclMjBzdHVkaW8lMjBtaXhpbmclMjBjb25zb2xlJTIwZGFya3xlbnwwfHx8YmxhY2t8MTc4Mzg5MzcxNHww&ixlib=rb-4.1.0&q=85",
    heroAlt: "Console de mixage FNK STUDIO",
    footerDesc: "FNK STUDIO : enregistrement, mix, master et beatmaking. Ouvert 24h/24 — 7j/7.",
  },
  films: {
    mode: "films",
    studioType: "media",
    brandFirst: "FNK",
    brandSecond: "FILMS",
    fullName: "FNK FILMS",
    logo: "/logo-fenek-films.jpg",
    subtitle: "Podcasts · Vidéo · Photo · Book · Clips · Interview",
    heroTitleA: "Votre espace",
    heroTitleAccentA: "photo & vidéo.",
    heroTitleB: "Donnez vie à vos projets",
    heroTitleAccentB: "visuels.",
    heroText:
      "Podcasts, vidéos, photos, books, clips et interviews dans un espace professionnel équipé, ouvert 24h/24.",
    heroImg:
      "https://images.unsplash.com/photo-1554048612-b6a482bc67e5?auto=format&fit=crop&w=1200&q=80",
    heroAlt: "Plateau photo et vidéo FNK FILMS",
    footerDesc:
      "FNK FILMS : podcasts, vidéo, photo, book, clips et interviews. Ouvert 24h/24 — 7j/7.",
  },
};

const rawMode = (process.env.REACT_APP_SITE_MODE || "studio").toLowerCase();
export const SITE_MODE = rawMode === "films" ? "films" : "studio";
export const SITE = SITE_CONFIG[SITE_MODE];
export const IS_STUDIO = SITE_MODE === "studio";
export const SITE_STUDIO_TYPE = SITE.studioType;
